import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { CheckListGroup } from './CheckListGroup';
import { CheckListItem } from './CheckListItem';

@Component({
    selector: 'multiselect-combobox',
    templateUrl: './multiselect-combobox.component.html',
    styleUrls: ['./multiselect-combobox.component.less'],
})
export class MultiselectComboboxComponent implements OnChanges {
    @Input() name: string;
    @Input() label: string;
    @Input() unselectedOptionLabel: string = 'Select Items';
    @Input() data: CheckListGroup[];
    @Output() dataChange = new EventEmitter();

    selectedItems: CheckListItem[] = new Array();
    isOpened = false;
    filterText = '';

    ngOnChanges({ data }: SimpleChanges) {
        setTimeout(() => this.updateSelected(), 1);
    }

    onChange() {
        this.updateSelected();
        this.dataChange.emit(this.data);
    }

    updateSelected() {
        this.selectedItems = new Array();
        this.data.forEach(i => {
            this.selectedItems = this.selectedItems.concat(i.items.filter((i) => i.checked));
        });
    }

    onOutsideClick() {
        this.isOpened = false;
    }

    processOpen() {
        if (!this.isOpened) {
            this.isOpened = true;
            this.filterText = '';

            setTimeout(() => {
                document.getElementById(this.name + 'search').focus();
            });
        }
    }

    clear() {
        this.data.forEach(g => g.items.forEach(i => i.checked = false));
        this.updateSelected();
        this.dataChange.emit(this.data);
    }
}
